import { useState } from 'react';

import { SignupFormA } from '../components/signup-form-a';
import { ThemeLayout } from '../components/theme/theme-layout';

const SignupA = ({ initialStep = 0 }: { initialStep?: number }) => {
  const [activeStep, setActiveStep] = useState(initialStep);
  return (
    <ThemeLayout variant={activeStep >= 1 ? 'centered' : 'split'}>
      <SignupFormA activeStep={activeStep} setActiveStep={setActiveStep} />
    </ThemeLayout>
  );
};

export default SignupA;
